import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { userService } from '../services/userService';
import { trackEventFavorited } from '../services/analyticsService';

export function useFavorites() {
  const { user } = useAuth();
  const [favoriteEvents, setFavoriteEvents] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      loadFavorites();
    } else {
      setFavoriteEvents([]);
    }
  }, [user]);

  const loadFavorites = async () => {
    if (!user) return;

    try {
      const userProfile = await userService.getUserProfile(user.uid);
      setFavoriteEvents(userProfile?.favoriteEvents || []);
    } catch (error) {
      console.error('Error loading favorites:', error);
    }
  };

  const toggleFavorite = async (eventId: string, category?: string) => {
    if (!user) return;

    setLoading(true);
    try {
      const wasFavorited = favoriteEvents.includes(eventId);

      if (wasFavorited) {
        await userService.removeFavoriteEvent(user.uid, eventId);
        setFavoriteEvents(prev => prev.filter(id => id !== eventId));
      } else {
        await userService.addFavoriteEvent(user.uid, eventId);
        setFavoriteEvents(prev => [...prev, eventId]);
      }

      trackEventFavorited({
        event_id: eventId,
        category: category || '',
        is_favorited: !wasFavorited,
      });
    } catch (error) {
      console.error('Error toggling favorite:', error);
    } finally {
      setLoading(false);
    }
  };

  const isFavorited = (eventId: string) => favoriteEvents.includes(eventId);

  return {
    favoriteEvents,
    loading,
    toggleFavorite,
    isFavorited
  };
}